import ApiService from '@/services/core/api.service'

const NewAccountService = {
  async get (query) {
    return ApiService.get(`dsm/new-accounts?${query}`)
  },

  async post (payload) {
    return ApiService.post('dsm/new-accounts', payload)
  },

  async put (payload) {
    return ApiService.put(`dsm/new-accounts/${payload.id}`, payload)
  }
}

export default NewAccountService
